import { ReactNode } from "react";
import { msalInstance } from "../../config/msalInstance";
import { getInitials } from "../../utils/format";
import { LogoutIcon } from "../ui/Icons";
import logoMark from "../../assets/logo-tw.svg";

interface IAppShellProps {
  user?: string;
  children: ReactNode;
}

export default function AppShell({ user, children }: IAppShellProps) {
  const handleLogout = (): void => {
    sessionStorage.clear();
    localStorage.clear();
    msalInstance.logoutRedirect();
  };

  return (
    <div className="shell">
      <header className="topbar">
        <div className="brand">
          <span className="brand__mark">
            <img src={logoMark} alt="Teamwork" />
          </span>
          <span className="brand__text">
            <span className="brand__title">Mensajería Confirmación de Beneficio</span>
            <span className="brand__sub">Seguimiento de mensajería WhatsApp</span>
          </span>
        </div>

        <div className="topbar__spacer" />

        {user && (
          <div className="account">
            <span className="account__mail" title={user}>
              {user}
            </span>
            <span className="account__avatar">{getInitials(user)}</span>
          </div>
        )}

        <button
          type="button"
          className="btn btn--sm btn--danger-ghost"
          onClick={handleLogout}
          title="Cerrar sesión"
        >
          <LogoutIcon size={15} />
          Salir
        </button>
      </header>

      <main className="main">{children}</main>
    </div>
  );
}
